<nav class="tab-container !pl-[20px]">
  <div>
    <button class="button" [ngClass]="{ 'active': currentTab === 'Drawing', 'inactive': currentTab !== 'Drawing' }" (click)="setTab('Drawing')">
      Drawings
    </button>
    <button class="button" [ngClass]="{ 'active': currentTab === 'Specifications', 'inactive': currentTab !== 'Specifications' }" (click)="setTab('Specifications')">
      Specifications
    </button>
    <button class="button" [ngClass]="{ 'active': currentTab === 'Calculations', 'inactive': currentTab !== 'Calculations' }" (click)="setTab('Calculations')">
      Calculations
    </button>
    <button class="button" [ngClass]="{ 'active': currentTab === 'Surveys, Reports and Studies', 'inactive': currentTab !== 'Surveys, Reports and Studies' }" (click)="setTab('Surveys, Reports and Studies')">
      Surveys, Reports and Studies
    </button>
    <button class="button" [ngClass]="{ 'active': currentTab === 'Design Review Reports', 'inactive': currentTab !== 'Design Review Reports' }" (click)="setTab('Design Review Reports')">
      Design Review Reports
    </button>
    <button class="button" [ngClass]="{ 'active': currentTab === 'Permits and Applications', 'inactive': currentTab !== 'Permits and Applications' }" (click)="setTab('Permits and Applications')">
      Permits and Applications
    </button>
    <button class="button" [ngClass]="{ 'active': currentTab === 'Design Sign Off', 'inactive': currentTab !== 'Design Sign Off' }" (click)="setTab('Design Sign Off')">
      Design Sign Off
    </button>
    <!-- <button class="button" [ngClass]="{ 'active': currentTab === 'RFI', 'inactive': currentTab !== 'RFI' }" (click)="setTab('RFI')">
      RFI
    </button> -->
  </div>
</nav>

<div class="tab-view" [ngClass]="{ 'active': currentTab === 'your_active_tab' }">
  <!-- Content for the active tab goes here -->
</div>
